import { ChangeDetectorRef, Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AutoComplete } from 'primeng/autocomplete';

@Component({
  selector: 'hub-autocomplete',
  templateUrl: './hub-autocomplete.component.html',
  styleUrls: ['./hub-autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HubAutocompleteComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => HubAutocompleteComponent),
      multi: true,
    },
  ],
})
export class HubAutocompleteComponent implements ControlValueAccessor {

  @Input() label: string = '';
  @Input() suggestions: any = [];
  @Input() placeholder: string = '';
  @Input() autofocus?: boolean = false;
  @Input() icon: string = '';
  @Input() iconColor?: string = '';
  @Input() isDisabled?: boolean = false
  @Input() allowClear?: boolean = false;
  @Input() labelColor?: string = '';
  @Input() required?: boolean = false;
  @Input() loading?: boolean = false;
  @Input() field: string;
  @Input() minLength : number = 4;
  @Input() forceSelection ?: boolean = true;
  @Input() errorLabel?: string = this.translate.instant('general.error.field_is_required');
  @Output() input = new EventEmitter<Event>(); // Add this output
  @Output() onSelect = new EventEmitter<Event>(); // Add this output
  @Output() completeMethod = new EventEmitter<Event>(); // Add this output

  value: any | null = null;
  disabled = false;

  @ViewChild('inputRef') inputElement!: AutoComplete;

  constructor(
    private cdr: ChangeDetectorRef,
    private translate: TranslateService
  ) { }

  ngAfterViewInit() {
    if (this.autofocus) {
      setTimeout(() => {
        this.inputElement.focused = true;
      });
    }
  }


  onChange = (value: any) => { };
  onTouched = () => { };

  writeValue(value: string | null): void {
    this.value = value;
  }


  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  validate(control: FormControl): ValidationErrors | null {
    return control.errors;
  }

  handleInputChange(event: any) {
    this.value = event.target.value;
    this.onChange(this.value); // 🔥 This triggers ngModelChange
    this.cdr.detectChanges(); // Trigger change detection
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  clearInput(): void {
    this.value = '';
    this.onChange(this.value);
    this.onTouched(); // Mark as touched
    this.input.emit();
  }

  onSelectMethod(event: any) {
    this.value = event.value ? event.value : event;
    this.onChange(this.value);
    this.onTouched();
    this.onSelect.emit(this.value);
    this.cdr.detectChanges();
  }

  onCompleteMethod(event: any) {
    console.log('onCompleteMethod', event);
    this.completeMethod.emit(event);
  }


}
